// import throttle from '../../helpers/throttle';

const megaMenu = ((document, $) => {
	const init = () => {
		const mq = window.matchMedia('(min-width: 1024px)');
		if (!mq.matches) {
			const customerServiceLink = document.querySelector('.menu-item-customer-service');
			if (customerServiceLink) {
				const customerServiceLinkClone = document
					.querySelector('.menu-item-customer-service')
					.cloneNode(true),
					mainNavListHolder = document.querySelector('.menu-primary');
				mainNavListHolder.appendChild(customerServiceLinkClone);
			}
			return;
		}
		const setSubMenuHeader = () => {
			const secondLevel = [
				...document.querySelectorAll('.sub-menu .menu-item-has-children > a'),
			];
			secondLevel.forEach((item) => {
				const nextUl = item.nextElementSibling.nextElementSibling;
				if (!nextUl) return;

				const headerText = item.textContent;
				const newHeader = document.createElement('li');
				newHeader.classList.add('menu-item', 'menu-item-list-header');
				newHeader.innerHTML = `<span itemprop="name">${headerText}</span>`;
				nextUl.prepend(newHeader);
			});
		};
		setSubMenuHeader();
		_checkSubmenuInViewport();
	};

	const _checkSubmenuInViewport = () => {
		const mq = window.matchMedia('(min-width: 1024px)');
		if (!mq.matches) return;

		const itemsWithChildren = document.querySelectorAll('.menu-item-has-children');
		itemsWithChildren.forEach((item) => {
			const link = item.querySelector('> a');
			const submenu = item.querySelector('.sub-menu');

			if (!submenu || !link) return;

			// Skip products-menu — mega menu is CSS-only via :hover
			if (item.classList.contains('products-menu')) return;

			// Add dropdown toggle arrow for desktop
			if (!link.querySelector('.desktop-dropdown-toggle')) {
				const toggleBtn = document.createElement('span');
				toggleBtn.className = 'desktop-dropdown-toggle';
				toggleBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M0.666016 0.666992L4.66602 4.66699L8.66602 0.666992" stroke="#21242C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>';
				link.appendChild(toggleBtn);

				// Handle dropdown toggle click
				toggleBtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					// Close other open dropdowns
					itemsWithChildren.forEach((otherItem) => {
						if (otherItem !== item) {
							const otherSubmenu = otherItem.querySelector('.sub-menu');
							if (otherSubmenu) {
								otherSubmenu.style.opacity = '0';
								otherSubmenu.style.visibility = 'hidden';
								otherItem.classList.remove('dropdown-open');
							}
						}
					});

					// Toggle current dropdown
					const isOpen = item.classList.contains('dropdown-open');
					if (isOpen) {
						submenu.style.opacity = '0';
						submenu.style.visibility = 'hidden';
						item.classList.remove('dropdown-open');
					} else {
						submenu.style.opacity = '1';
						submenu.style.visibility = 'visible';
						item.classList.add('dropdown-open');

						// Check viewport position
						const rect = submenu.getBoundingClientRect();
						if (rect.right > window.innerWidth) {
							submenu.classList.add('submenu-out-of-viewport');
						} else {
							submenu.classList.remove('submenu-out-of-viewport');
						}
					}
				});
			}

			// Close dropdown when clicking outside
			document.addEventListener('click', function(e) {
				if (!item.contains(e.target)) {
					submenu.style.opacity = '0';
					submenu.style.visibility = 'hidden';
					item.classList.remove('dropdown-open');
				}
			});
		});
	};
	return { init };
})(document, jQuery);

export default megaMenu;

// ============================================
// Main Menu, Flyout, and Dropdown Toggle Logic
// ============================================

document.addEventListener('DOMContentLoaded', function () {
	const burger = document.querySelector('.localads-header-top__burger');
	const flyout = document.getElementById('localads-header-flyout');
	const closeBtn = document.querySelector('.localads-header-flyout__close');
	const overlay = document.querySelector('.localads-header-flyout__overlay');

	console.log('Burger menu debug:', { burger, flyout, closeBtn, overlay });

	if (!burger) {
		console.error('Burger button not found!');
		return;
	}

	if (!flyout) {
		console.error('Flyout menu not found!');
		return;
	}

	function openFlyout() {
		flyout.classList.add('is-open');
		burger.classList.add('is-active');
		burger.setAttribute('aria-expanded', 'true');
		flyout.setAttribute('aria-hidden', 'false');
		document.body.style.overflow = 'hidden';
		if (closeBtn) closeBtn.focus();
		console.log('Flyout opened');
	}

	function closeFlyout() {
		flyout.classList.remove('is-open');
		burger.classList.remove('is-active');
		burger.setAttribute('aria-expanded', 'false');
		flyout.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';
		burger.focus();
		console.log('Flyout closed');
	}

	// ✅ Toggle open/close
	burger.addEventListener('click', () => {
		const isOpen = flyout.classList.contains('is-open');
		isOpen ? closeFlyout() : openFlyout();
	});

	if (closeBtn) closeBtn.addEventListener('click', closeFlyout);
	if (overlay) overlay.addEventListener('click', closeFlyout);

	document.addEventListener('keydown', function (e) {
		if (flyout.classList.contains('is-open') && e.key === 'Escape') {
			closeFlyout();
		}
	});

	// =====================================
	// 🔽 Add dropdown-toggle to ALL menu-item-has-children
	// =====================================
	function initDropdownToggles() {
		console.log('🔽 Initializing dropdown toggles for menu-item-has-children...');

		const parentItems = document.querySelectorAll('.menu-item-has-children');

		parentItems.forEach(item => {
			const link = item.querySelector('a');
			const submenu = item.querySelector('.sub-menu');

			if (!submenu) return;

			// Add toggle if not present
			if (!item.querySelector('.dropdown-toggle')) {
				const toggle = document.createElement('span');
				toggle.className = 'dropdown-toggle';
				toggle.setAttribute('aria-expanded', 'false');
				item.insertBefore(toggle, submenu);
			}

			const toggleButton = item.querySelector('.dropdown-toggle');

			toggleButton.addEventListener('click', e => {
				e.preventDefault();
				e.stopPropagation();

				const isOpen = item.classList.contains('is-open');

				if (isOpen) {
					submenu.style.display = 'none';
					item.classList.remove('is-open');
					toggleButton.setAttribute('aria-expanded', 'false');
				} else {
					submenu.style.display = 'block';
					item.classList.add('is-open');
					toggleButton.setAttribute('aria-expanded', 'true');
				}
			});

			// Keep the link clickable - don't prevent navigation
			// Remove the link click handler that was preventing default
		});
	}

	// =====================================
	// Init Menus
	// =====================================
	initDropdownToggles();

	// Re-init when flyout opens
	if (burger) {
		burger.addEventListener('click', () => {
			setTimeout(() => {
				initDropdownToggles();
			}, 300);
		});
	}
});

// =====================================
// Scroll detection for fixed header
// =====================================
(function () {
	const topBar = document.querySelector('.localads-top-bar');
	const headerTop = document.querySelector('.localads-header-top');
	const siteHeader = document.querySelector('.site-header');
	const logo = document.querySelector('.localads-logo');
	const body = document.body;

	let ticking = false;
	let headerHeight = siteHeader ? siteHeader.offsetHeight : 0;

	function updateHeaderOnScroll() {
		const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollPosition > 100) {
			if (topBar) topBar.classList.add('scrolled');
			if (headerTop) headerTop.classList.add('scrolled');
			if (siteHeader) {
				siteHeader.classList.add('scrolled');
				body.style.paddingTop = headerHeight + 'px';
			}
			if (logo) logo.classList.add('scrolled');
		} else {
			if (topBar) topBar.classList.remove('scrolled');
			if (headerTop) headerTop.classList.remove('scrolled');
			if (siteHeader) {
				siteHeader.classList.remove('scrolled');
				body.style.paddingTop = '0';
			}
			if (logo) logo.classList.remove('scrolled');
		}
		ticking = false;
	}

	function requestTick() {
		if (!ticking) {
			window.requestAnimationFrame(updateHeaderOnScroll);
			ticking = true;
		}
	}

	window.addEventListener('scroll', requestTick, { passive: true });
	updateHeaderOnScroll();
})();
